import { FormEvent } from "react";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { getValidationNameAndMaskedValue, getErrorMessage, hasErrors, validateInputOrFieldSet } from "./actions.util";
import * as AT from "./actionTypes";
import { RootState, ValidationField } from "../../../../models";
import { allValidationRules } from "../formValidation";

export const onChangedValue = (
    formId: string,
    inputName: string,
    inputValue: string,
    previousInputValue: string,
    shouldValidate: boolean,
    visible: boolean,
) => {
    const { validationName, maskedValue } = getValidationNameAndMaskedValue(inputName, inputValue, previousInputValue);
    const started = shouldValidate && (maskedValue || "").length > 0;

    let errorMessage;
    if (shouldValidate && started) {
        errorMessage = getErrorMessage(maskedValue, allValidationRules[validationName]);
    }
    return {
        type: AT.FORM_VALUE_CHANGED(formId),
        payload: {
            errorMessage,
            form: formId,
            inputName,
            inputValue: maskedValue,
            visible,
            started,
        },
    };
};

export const onRemoveInput = (formId: string, inputName: string) => {
    return {
        type: AT.FORM_REMOVE_INPUT(formId),
        payload: {
            inputName,
        },
    };
};

export const onRemoveField = (formId: string, fieldName: string) => {
    return {
        type: AT.FORM_REMOVE_FIELD(formId),
        payload: {
            inputName: fieldName,
        },
    };
};

export const clearAll = (formId: string) => ({
    type: AT.FORM_CLEAR_ALL(formId),
});

export const validateForm =
    (
        e: FormEvent,
        formId: string,
        values: ValidationField,
        visible: ValidationField,
        callback: () => void,
    ): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        e.preventDefault();
        e.stopPropagation();
        const errors = validateInputOrFieldSet(values, visible);
        if (!hasErrors(errors)) {
            callback();
        } else {
            dispatch({
                type: AT.FORM_VALIDATE_ALL(formId),
                payload: {
                    errors,
                },
            });
        }
    };
